import { Box, Typography } from '@mui/material';
import { CheckCircleOutlined } from '@mui/icons-material';
import { TextField } from '../../../../v2/MUI_custom_component';

const calculateAge = (dob) => {
  const [yyyy, mm, dd] = dob.split('-');
  const birth = new Date(`${yyyy}-${mm}-${dd}`);
  const today = new Date();
  let age = today.getFullYear() - birth.getFullYear();
  const m = today.getMonth() - birth.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birth.getDate())) age--;
  return age;
};

const DigiLockerResultCard = ({ data }) => {
  const age = data?.date_of_birth ? calculateAge(data.date_of_birth) : '';
  const gender = data?.gender
    ? data.gender.charAt(0) + data.gender.slice(1).toLowerCase()
    : '-';

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
        <CheckCircleOutlined sx={{ color: 'green', fontSize: 24 }} />
        <Typography variant='body1' sx={{ color: '#000' }}>
          Digi-Locker Captured
        </Typography>
      </Box>

      <Box sx={{ display: 'flex', gap: 2 }}>
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <TextField label='Name' value={data?.name || '-'} fetchedState={true} fullWidth />
        </Box>
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <TextField label='Gender' value={gender} fetchedState={true} fullWidth />
        </Box>
      </Box>

      <Box sx={{ display: 'flex', gap: 2 }}>
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <TextField label='Date of Birth' value={data?.date_of_birth || '-'} fetchedState={true} fullWidth />
        </Box>
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <TextField label='Age' value={age ? `${age}y` : '-'} fetchedState={true} fullWidth />
        </Box>
      </Box>
    </Box>
  );
};

export default DigiLockerResultCard;
